import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { SegmentCardCommentEditTargetOptionValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { TCardId } from '../../../../../../../../types/types';

export const onLoad = (
    cardId: TCardId,
): ThunkAction => {
    return (dispatch: Dispatch) => {
       return Promise.resolve(); // todo 4449 onLoad
    };
};
